import { createReducer } from '@reduxjs/toolkit'
import {
  getActivityConfigAction,
  getAllRankAction,
  getDayRankAction,
  getRewardHistoryAction,
  getUserInfoAction,
  updateRankTypeAction,
} from './actions'
import { LoayltyState, RankType } from './types'

const initialState: LoayltyState = {
  rankType: RankType.all,
  userInfo: {
    userPointRankVO: {
      id: 0,
      userId: 0,
      address: '',
      inviteUserId: 0,
      inviteUserNum: 0,
      pointTotal: 0,
      boost: 0,
      role: 0,
      level: 0,
      tradeNum: 0,
      tradeAvailable: 0,
      isWhite: true,
      isValid: true,
      createTime: 0,
      updateTime: 0,
    },
    userPointDayRankVO: undefined,
    rank: 0,
    dayRank: 0,
    userRewardVOList: [],
  },
  config: {
    name: '',
    code: '',
    attributes: {
      start: 0,
      end: 0,
      rebates: {},
      chests: [],
      userCreatedReward: {
        quantity: 0,
      },
      userInvitedReward: {
        requiredTradeVol: 0,
        quantity: 0,
      },
      orderFilledReward: {
        levels: {},
      },
    },
    chestMap: {},
    chests: [],
    userCreatedReward: {
      quantity: 0,
    },
    userInvitedReward: {
      requiredTradeVol: 0,
      quantity: 0,
    },
    valid: true,
  },
  allRank: {
    records: [],
    total: 0,
    size: 0,
    current: 0,
    pages: 0,
  },
  dayRank: {
    records: [],
    total: 0,
    size: 0,
    current: 0,
    pages: 0,
  },
  rewardHistory: {
    records: [],
    total: 0,
    size: 0,
    current: 0,
    pages: 0,
  },
}

export default createReducer<LoayltyState>(initialState, (builder) => {
  builder
    .addCase(updateRankTypeAction, (state, { payload }) => {
      state.rankType = payload.type
    })
    .addCase(getUserInfoAction.fulfilled, (state, { payload }) => {
      state.userInfo = payload
    })
    .addCase(getActivityConfigAction.fulfilled, (state, { payload }) => {
      state.config = payload
    })
    .addCase(getAllRankAction.fulfilled, (state, { payload }) => {
      state.allRank = payload
    })
    .addCase(getDayRankAction.fulfilled, (state, { payload }) => {
      state.dayRank = payload
    })
    .addCase(getRewardHistoryAction.fulfilled, (state, { payload }) => {
      state.rewardHistory = payload
    })
})
